/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ChangeHistorySection = {
    Overview: 'Overview',
    PersonalData: 'PersonalData',
    GoalsResults: 'GoalsResults',
    MeasuresCauses: 'MeasuresCauses',
    StatusCounselor: 'StatusCounselor',
    CaseNotes: 'CaseNotes',
    AssetPersonalData: 'AssetPersonalData',
    AssetRelatives: 'AssetRelatives',
    AssetIncome: 'AssetIncome',
    Claims: 'Claims',
    DangerousDebts: 'DangerousDebts',
    SpecialDebts: 'SpecialDebts',
    BankruptcyConsequences: 'BankruptcyConsequences',
    ClientSpecificCreditor: 'ClientSpecificCreditor',
    SrvProceeding: 'SrvProceeding',
    AssetExpenses: 'AssetExpenses',
    AssetOwnClaims: 'AssetOwnClaims',
    AssetAssets: 'AssetAssets',
    AssetPropertyRights: 'AssetPropertyRights',
    AssetDonations: 'AssetDonations',
    ClientNote: 'ClientNote'
} as const;
export type ChangeHistorySection = typeof ChangeHistorySection[keyof typeof ChangeHistorySection];


export function instanceOfChangeHistorySection(value: any): boolean {
    for (const key in ChangeHistorySection) {
        if (Object.prototype.hasOwnProperty.call(ChangeHistorySection, key)) {
            if (ChangeHistorySection[key as keyof typeof ChangeHistorySection] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ChangeHistorySectionFromJSON(json: any): ChangeHistorySection {
    return ChangeHistorySectionFromJSONTyped(json, false);
}

export function ChangeHistorySectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangeHistorySection {
    return json as ChangeHistorySection;
}

export function ChangeHistorySectionToJSON(value?: ChangeHistorySection | null): any {
    return value as any;
}

export function ChangeHistorySectionToJSONTyped(value: any, ignoreDiscriminator: boolean): ChangeHistorySection {
    return value as ChangeHistorySection;
}

